import { i18n as globalI18n } from '@zet/localization'
import storage from '@zet/utils/storage'

import english from './en.json'
import hindi from './hi.json'

const availableLanguages = [
  { name: 'English', code: 'en' },
  { name: 'हिन्दी', code: 'hi' },
]

const localizationObj = {
  en: english,
  hi: hindi,
}

// Initialize with stored locale or use global default
const initializeLocale = async () => {
  const storedLocale = await storage.getObject('locale')
  const targetLocale = storedLocale || globalI18n.locale || 'en'

  globalI18n.store(localizationObj)
  globalI18n.locale = targetLocale
}

// Initialize immediately
initializeLocale()

export { availableLanguages, globalI18n as i18n }
